import { render, staticRenderFns } from "./DateInputForm.vue?vue&type=template&id=54c70d2a&scoped=true&"
import script from "./DateInputForm.vue?vue&type=script&lang=js&"
export * from "./DateInputForm.vue?vue&type=script&lang=js&"
import style0 from "./DateInputForm.vue?vue&type=style&index=0&id=54c70d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c70d2a",
  null
  
)

export default component.exports